// ================================================================
//  agencySearch — one shared matcher for every "search agencies /
//  clients" box in the dashboard, so they all behave the same.
//
//  Matches (case-insensitive, substring) against:
//    agency_name, software_key (Software ID), phone, mobile
//  Pass `extraFields` to widen it, e.g. ["place"].
//
//  Phone-like queries also match ignoring spaces, dashes, brackets
//  and a leading +, so "98470 12345" finds "9847012345".
// ================================================================

const DEFAULT_FIELDS = ["agency_name", "software_key", "phone", "mobile"];
const PHONE_FIELDS = new Set(["phone", "mobile"]);

const asText = (v) => (v === null || v === undefined ? "" : String(v)).toLowerCase();
const digitsOnly = (v) => asText(v).replace(/\D/g, "");

export const matchesAgency = (agency, query, extraFields = []) => {
    const q = asText(query).trim();
    if (!q) return true;
    if (!agency) return false;

    // Only treat the query as a phone number if it has no letters.
    const qDigits = /^[\d\s()+\-.]+$/.test(q) ? digitsOnly(q) : "";

    return [...DEFAULT_FIELDS, ...extraFields].some((field) => {
        const value = agency[field];
        if (asText(value).includes(q)) return true;
        return PHONE_FIELDS.has(field) && qDigits !== "" && digitsOnly(value).includes(qDigits);
    });
};
